// var ua = require("express-useragent").parse(window.navigator.userAgent);
const ua = require("platform");

ua.isIOS = ua.os.family === "iOS";
ua.isiPhone = ua.product === "iPhone";
ua.isSafari = ua.name === "Safari";
ua.isChrome = ua.name === "Chrome Mobile" || navigator.userAgent.match("CriOS");
ua.isFirefox = ua.name.includes("Firefox") || navigator.userAgent.match("FxiOS");
ua.isTelegramWebView = window.Telegram || window.TelegramWebviewProxy || window.TelegramWebview;
ua.isIOSWebView = ua.isIOS && !(/Safari/i).test(navigator.userAgent);

ua.isIOS13 = () => {
	if ((/iP(hone|od|ad)/).test(navigator.platform)) {
		const v = navigator.appVersion.match(/OS (\d+)_(\d+)_?(\d+)?/);

		return parseInt(v[1], 10) === 13;
	}

	return false;
};

ua.isIpadOS = navigator.maxTouchPoints && navigator.maxTouchPoints > 2 && (/MacIntel/).test(navigator.platform);
// eslint-disable-next-line max-len
ua.isDesktop = !((/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i).test(navigator.userAgent) || ua.isIpadOS);

if ((navigator.userAgent.match(/Android/i)) || navigator.userAgent.match(/HTC_Sensation/i)) {
	ua.isAndroid = true;
}

ua.isDesktopChrome = ua.name.includes("Chrome");
ua.isDesktopFirefox = ua.name.includes("Firefox");
ua.isDesktopOpera = ua.name.includes("Opera");
ua.isDesktopSafari = ua.name.includes("Safari");
ua.isDesktopIE = ua.name.includes("IE");

module.exports = ua;



// WEBPACK FOOTER //
// ./js/useragent.js